module.exports = __webpack_public_path__ + "img/remainder1.4b03a565.svg";